import { createContext, useContext, useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import Axios from "axios"
import Swal from 'sweetalert2'
import i18n from 'i18next'

export const AuthContext = createContext()

const useLogoutClient = () => {
    return async () => {
        localStorage.removeItem("jwt")
    }
}

const useLoginClient = (setClientauth) => {
    const navigate = useNavigate()

    return async (userCredentials) => {
        const options = {
            headers: { "Access-Control-Allow-Origin": "*" },
        }

        try {
            const result = await Axios.post(
                process.env.REACT_APP_DB_ADDRESS + "/api/login/in",
                { email: userCredentials.email, password: userCredentials.password },
                options
            )

            const token = result.data["token"]

            if (token && token !== "undefined") {
                localStorage.setItem("jwt", token)
                const decoded = jwtDecode(token)
                const role = String(decoded.rol || '').toLowerCase()

                setClientauth(decoded)

                if (role === "admin") {
                    navigate('/admin/dashboard')
                    return true
                }

                if (role === "department") {
                    navigate('/department/dashboard')
                    return true
                }

                if (role === "commercial") {
                    navigate('/commercial/dashboard')
                    return true
                }

                if (window.location.pathname !== '/') {
                    navigate('/')
                }

                return false
            }

            Swal.fire({
                showConfirmButton: true,
                confirmButtonColor: '#3085d6',
                confirmButtonText: i18n.t('global.close'),
                icon: 'error',
                text: result.data.message,
            })
            return false
        } catch (error) {
            console.error("Error al iniciar sesion:", error)
            Swal.fire({
                showConfirmButton: true,
                confirmButtonColor: '#3085d6',
                confirmButtonText: i18n.t('global.close'),
                icon: 'error',
                text: i18n.t('auth.loginError'),
            })
            return false
        }
    }
}

export function AuthProvider({ children }) {
    const [clientauth, setClientauth] = useState(null)
    const loginClient = useLoginClient(setClientauth)
    const logoutClient = useLogoutClient()
    const storedToken = localStorage.getItem("jwt")

    useEffect(() => {
        try {
            setClientauth(storedToken ? jwtDecode(storedToken) : null)
        } catch (error) {
            console.error("Error al decodificar el token:", error)
            setClientauth(null)
            localStorage.removeItem("jwt")
        }
    }, [storedToken])

    const contextValue = { clientauth, loginClient, logoutClient, logout: logoutClient, setClientauth }

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    )
}

export function useAuth() {
    const context = useContext(AuthContext)
    return context
}
